/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_GetReleaseDto } from '../models/PagedResultDto_GetReleaseDto';
import type { PagedResultDto_IncludedReleaseDetailDto } from '../models/PagedResultDto_IncludedReleaseDetailDto';
import type { PagedResultDto_ReleaseDetailDto } from '../models/PagedResultDto_ReleaseDetailDto';
import type { PagedResultDto_ReleaseOutputListDto } from '../models/PagedResultDto_ReleaseOutputListDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_StatusDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_StatusDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseItemDetailDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseItemDetailDto';
import type { Wealthlane_AwardService_Dtos_Release_ReleaseOutputDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseOutputDto';
import type { Wealthlane_AwardService_Dtos_Release_StatusDto } from '../models/Wealthlane_AwardService_Dtos_Release_StatusDto';
import type { Wealthlane_AwardService_Dtos_Release_TransactionDetailDto } from '../models/Wealthlane_AwardService_Dtos_Release_TransactionDetailDto';
import type { Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto } from '../models/Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReleaseAppSharedService {

    /**
     * @param id
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @param searchKeyWord
     * @param grantId
     * @param awardTypeId
     * @param fromDate
     * @param toDate
     * @param settlementTypeIds
     * @returns PagedResultDto_IncludedReleaseDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseIncludedReleaseList(
        id: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
        searchKeyWord?: string,
        grantId?: string,
        awardTypeId?: string,
        fromDate?: string,
        toDate?: string,
        settlementTypeIds?: Array<string>,
    ): CancelablePromise<PagedResultDto_IncludedReleaseDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/{id}/included-release-list',
            path: {
                'id': id,
            },
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'GrantId': grantId,
                'AwardTypeId': awardTypeId,
                'FromDate': fromDate,
                'ToDate': toDate,
                'SettlementTypeIds': settlementTypeIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId
     * @returns Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleasePsuTransactionListByAwardId(
        awardId: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/psu-transaction-list-by-award-id/{AwardId}',
            path: {
                'AwardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @param searchKeyWord
     * @param name
     * @param expectedReleaseDate
     * @param releaseStatusId
     * @returns PagedResultDto_GetReleaseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseReleaseList(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
        searchKeyWord?: string,
        name?: string,
        expectedReleaseDate?: string,
        releaseStatusId?: number,
    ): CancelablePromise<PagedResultDto_GetReleaseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/release-list',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'Name': name,
                'ExpectedReleaseDate': expectedReleaseDate,
                'ReleaseStatusId': releaseStatusId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardId
     * @returns Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseRsuTransactionListByAwardId(
        awardId: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/rsu-transaction-list-by-award-id/{AwardId}',
            path: {
                'AwardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @param searchKeyWord
     * @param grantId
     * @param awardTypeId
     * @param fromDate
     * @param toDate
     * @param settlementTypeIds
     * @returns PagedResultDto_ReleaseDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseVestingList(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
        searchKeyWord?: string,
        grantId?: string,
        awardTypeId?: string,
        fromDate?: string,
        toDate?: string,
        settlementTypeIds?: Array<string>,
    ): CancelablePromise<PagedResultDto_ReleaseDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/vesting-list',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'GrantId': grantId,
                'AwardTypeId': awardTypeId,
                'FromDate': fromDate,
                'ToDate': toDate,
                'SettlementTypeIds': settlementTypeIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseReleaseSummary(
        id: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseOutputDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/{id}/release-summary',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param releaseId
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseReleaseById(
        releaseId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/release-by-id/{releaseId}',
            path: {
                'releaseId': releaseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param releaseItemId
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseItemDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseReleaseItemDetail(
        releaseItemId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseItemDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/release-item-detail/{releaseItemId}',
            path: {
                'releaseItemId': releaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param releaseItemId
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseTaxDetailsByReleaseItemId(
        releaseItemId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/tax-details-by-release-item-id/{releaseItemId}',
            path: {
                'releaseItemId': releaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param releaseItemId
     * @returns Wealthlane_AwardService_Dtos_Release_TransactionDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseTransactionDetail(
        releaseItemId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_TransactionDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/transaction-detail/{releaseItemId}',
            path: {
                'releaseItemId': releaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Release_StatusDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseReleaseStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Release_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/release-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_StatusDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseAwardTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionExercise_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/award-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @param searchKeyWord
     * @param grantId
     * @param awardTypeId
     * @param fromDate
     * @param toDate
     * @param settlementTypeIds
     * @returns PagedResultDto_ReleaseOutputListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppReleaseReleaseDetail(
        id: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
        searchKeyWord?: string,
        grantId?: string,
        awardTypeId?: string,
        fromDate?: string,
        toDate?: string,
        settlementTypeIds?: Array<string>,
    ): CancelablePromise<PagedResultDto_ReleaseOutputListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/release/{id}/release-detail',
            path: {
                'id': id,
            },
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'GrantId': grantId,
                'AwardTypeId': awardTypeId,
                'FromDate': fromDate,
                'ToDate': toDate,
                'SettlementTypeIds': settlementTypeIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
